import { Modal } from "react-bootstrap";
import { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useFooterData } from "../../provider/billingProviders/footerDataProvider";

const NotesModal = ({ open = false, onClose = () => {} }) => {
  const [notes, setNotes] = useState("");
  const { footerData, setFooterData } = useFooterData();
  useEffect(() => {
    setNotes(footerData.notes);
  }, [footerData.notes]);
  return (
    <Modal
      show={open}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      onHide={() => onClose()}
    >
      <Modal.Header>
        <div>
          <h4 style={{ color: "#EF4667", marginBottom: 0 }}>NOTES</h4>
        </div>
      </Modal.Header>
      <Modal.Body>
        <Form.Control
          as="textarea"
          rows={5}
          value={notes}
          onChange={(e) => setNotes(e.target.value)}
        />
        <p
          style={{
            textAlign: "right",
            fontSize: 10,
            color: "#3f3f3f",
            marginBottom: 0,
            marginTop: 5,
          }}
        >
          Char count {notes.length}/250
        </p>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="cancelButton"
          onClick={() => {
            onClose(false);
          }}
        >
          Cancel
        </button>
        <button
          className="addAddrButton"
          onClick={() => {
            onClose(false);
            setFooterData((prev) => ({
              ...prev,
              notes: notes,
            }));
          }}
        >
          ADD NOTES
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default NotesModal;
